import { Box, Card } from '@mui/material'
import ApplicationBar from 'components/AppBar/ApplicationBar'
import React from 'react'

interface AppBarLayoutProps {
    children: React.ReactNode
    hasCardBg?: boolean
}

function AppBarLayout({ children, hasCardBg = false }: AppBarLayoutProps) {
    const [height, setHeight] = React.useState(window.innerHeight - 96)

    React.useEffect(() => {
        function onResize() {
            setHeight(window.innerHeight - 96)
        }

        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])

    return (
        <Box
            sx={{
                backgroundColor: (theme) => theme.palette.background.default,
                height: '100%',
                minHeight: '100vh',
            }}
        >
            <ApplicationBar menuToggleBtn={false} />
            {hasCardBg ? (
                <Card
                    sx={{
                        margin: 16,
                        padding: {
                            md: '16px',
                            lg: '16px 80px',
                        },
                    }}
                    style={{ height }}
                >
                    {children}
                </Card>
            ) : (
                <Box
                    sx={{
                        margin: '16px',
                        padding: {
                            md: '16px',
                            lg: '16px 80px',
                        },
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    )
}

export default AppBarLayout
